<template>
  <div class="charge">
    <Loading v-show="loading"></Loading>
    <h1>ログイン</h1>
    <a href="/"><img id="close" src="../../assets/close.png" alt=""></a>
    <div id="tab">
      <ul class="tabMenu">
        <li class="tabItem" v-for="(tab,index) in tabs" v-on:click="activetab=(index+1)" v-bind:class="[ activetab === (index+1) ? 'active' : '' ]">{{tab.tabitem}}</li>
      </ul>
      <div v-if="activetab === 1">
        <p class="caution-text">現在インスタグラムではログインできません。メールアドレスでログインをお願い致します！</p>
        <div style="height:500px;">
        </div>
      </div>
      <div class="form" v-else>
        <p class="title">メールアドレス</p>
        <input type="email" v-model="mail" placeholder="例）calorie@gmail.com">
        <label>新規登録時に登録したログインID(メールアドレス)</label>
        <p class="title">パスワード</p>
        <input type="password" v-model="password" id="password" placeholder="例）2700abcd">
        <div style="text-align:left;"><input type="checkbox" style="width:auto;" v-model="isCheckedPasword" v-on:change="checkPasword">パスワードを表示する</div>
        <label>新規登録時に登録したパスワード(任意の英数字)</label>
       
        <div style="height:200px;">
      <button id="login" type="" v-on:click="login()">ログイン</button>
      <a href="/forget" id="forget">パスワードを忘れた方はこちら</a>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
*{
  box-sizing: border-box;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
#tab{
  max-width: 40%;
  margin: 16px auto;
}

.tabMenu{
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  list-style: none;
  border-bottom: 1px solid black;
}
#forget{
  color: black;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.tabItem.active{
  background-color: black;
  color: #fff;
}
.key{
  width: 30%;
  background:black;
  color: white;
}
table{
  border-spacing: 0px;
  width: 100%;
  border: 1px solid black;
}
table tr{
  height: 80px;
}
.caution-text{
  font-family: Hiragino Kaku Gothic Pro;
  text-align: center;
}
.value{
  font-size: 24px;
  font-weight: bold;
}
span{
  font-size: 12px;
  font-weight: normal;
  font-family: Hiragino Kaku Gothic Pro;
}
.charge{
  position: relative;
}
#close{
  position: absolute;
  top:0%;
  left:20%;
}
.form .title{
  margin-top: 5%;
  text-align: left;
}
.form input{
  width: 100%;
  padding:8px;
  font-size: 24px;
}
.form label{
 font-size: 12px;
 text-align: left;
 width: 100%;
 display: block;

}
.form table{
  margin-top: 5%;
  margin-bottom: 5%;
}
.bold{
  font-weight: bold;
}
.privacy{
  font-size: 12px;
  color: black;
}
.privacy a{
  color: black;
  text-decoration: underline;
}
#login{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:5% auto;
  border:0px;
  width: 100%;
}
@media ( max-width : 600px ){
  h1{
    font-size: 18px;
  }
  #tab{
  max-width: 100%;
  margin: 16px auto;
}
#close{
  position: absolute;
  top:8px;
  left:5%;
  width: 16px;
}
#tab li{
  font-size: 12px;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.form{
 margin-left: 16px;
 margin-right: 16px;
}
#payButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
  border:0px;
}
.form input[data-v-4c82ff2f] {
    width: 100%;
    padding: 8px;
    font-size: 14px;
}
}
formfield {
  float: left;
  width: 100%;
}

label {
  float: left;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6em;
  margin-bottom: 5px;
  color: #92A3A6;
}

input, select, button {
  float: left;
  background: transparent;
  border: 2px solid #EBEBEB;
  border-radius: 3px;
  padding: 5px 10px;
  margin: 0 10px 10px 0;
  font-size: 1.2em;
  line-height: 2em;
  transition: border 300ms ease-in;
}

input:focus, select:focus {
  border-color: #20A8FF;
}

input::-webkit-input-placeholder {
  color: rgba(146,163,166,.5);
}


#ccn input[type="text"] {
  width: calc(25% - 10px);
  letter-spacing: 2px;
  text-align: center;
}

#ch input[type="text"] {
  width: calc(50% - 10px);
  text-align: start;
}

#ed, #sc {
  width: 50%;
}

#sc input[type="text"] {
  width: calc(100% - 10px);
}

#ed select {
  background: #fff;
  height: 46px;
  width: calc(50% - 10px);
  line-height: 2em;
  text-align: center;
  font-size: 14px;
}

#cc {
  width: 50%;
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Plan',
  components: {
    Loading
  },
  data () {
    return {
      db: null,
      loading: false,
      isCheckedPasword: false,
      activetab: 2,
      mail: null,
      password: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/,
      halfsizePattern: /^[A-Za-z0-9]*$/,
      halfNumsizePattern: /^[0-9]*$/,
    tabs: [
      { tabitem: "Instagramでログイン" },
      { tabitem: "メールアドレスでログイン" }
    ],
    contents: [
      {
        position: 0
      },
      {
        position: 1
      }
    ]
    }
  },
  methods: {
    checkPasword: function () {
      var pw = document.getElementById('password')
      if(this.isCheckedPasword) {
        pw.setAttribute('type', 'text')
      } else {
        pw.setAttribute('type', 'password')
      }
    },
    login: function () {
      // メールアドレスの入力確認
      if (!this.mail) {
        alert('メールアドレスの入力をしてからログインボタンを押しましょう')
        return
      }
      if (!this.mailPattern.test(this.mail)) {
        alert('メールアドレスの入力が正しくありません。')
        return
      }
      //パスワード入力確認
      if (!this.password) {
        alert('パスワードの入力をしてからログインボタンを押しましょう')
        return
      }
      //サーバーに問い合わせ
      var exist = false
      this.loading = true
      let self = this
      var db = this.db
      db.collection('users').where('mail', '==', this.mail).where('password', '==', this.password).get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          localStorage.userId = doc.id
          location.href = '/mypage?userId=' + doc.id
          exist = true
        })
        if (!exist) {
          alert('入力されたIDとパスワードを持つユーザーは存在しません。ID・パスワードを忘れた方は「忘れた方はこちら」からお問い合わせください。')
          self.loading = false
          return
        }
      })
        .catch(function (error) {
          console.log(error)
          alert('登録に失敗しました。エラーです。')
          self.loading = false
          return
        })
    }
  },
  created: function () {
    this.db = firebase.firestore()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/Login.vue